export const CouponsMenu = 'CouponsMenu';
export const KybReviewMenu = 'KybReviewMenu';
export const NpwpReviewMenu = 'NpwpReviewMenu';
export const BillingReviewMenu = 'BillingReviewMenu';
export const ResetPhoneMenu = 'ResetPhoneMenu';
export const ForceActivationMenu = 'ForceActivationMenu';
export const OutletBulkUpdateExpirationMenu = 'OutletBulkUpdateExpirationMenu';
export const AccessMenu = 'AccessMenu';
export const UserMappingMenu = 'UserMappingMenu';
export const BusinessMenu = 'BusinessMenu';
export const DiscountsMenu = 'DiscountsMenu';
export const DiscountRulesMenu = 'DiscountRulesMenu';
export const DeleteBusinessMenu = 'DeleteBusinessMenu';
export const ChangeUserEmailMenu = 'ChangeUserEmailMenu';
export const BillingPackagesMenu = 'BillingPackagesMenu';
export const HardwareCataloguesMenu = 'HardwareCataloguesMenu';
